import QueryString from 'qs'
import Consultation, { ConsultationState } from '~models/consultation'
import Owner from '~models/owner'
import Pet from '~models/pet'
import api from '~utils/http'

type ConsultationPaginationParams = Readonly<PaginationParams & ConsultationState>

class AppDataRepositoryImpl {
  async getMyProfile() {
    const response = (
      await api.get<Owner.ILevel2>('/app/owner/me/', {
        withCredentials: true,
      })
    ).data

    /**
     * @TODO: MODEL_QUERY_KEYS.owner 에 데이터를 저장
     */

    return new Owner.Level2(response)
  }

  async updateMyProfile(
    draft: Partial<
      Pick<Owner.ILevel2, 'nickname' | 'thumbnail_uri' | 'phone_number'> & {
        token?: string
        code?: string
      }
    >
  ) {
    return new Owner.Level2(
      (
        await api.patch<Owner.ILevel2>('/app/owner/me/', { ...draft }, { withCredentials: true })
      ).data
    )
  }

  async getMyPets() {
    const response = (
      await api.get<Pet.ILevel1[]>('/app/owner/pets/', {
        withCredentials: true,
      })
    ).data

    /**
     * @TODO: MODEL_QUERY_KEYS.pets 에 데이터를 저장
     */

    return response.map(pet => new Pet.Level1(pet))
  }

  async getPagedMyConsultations(params?: ConsultationPaginationParams) {
    const response = (
      await api.get<Paging<Consultation.ILevel1>>('/app/owner/consultations/', {
        withCredentials: true,
        params,
        paramsSerializer: params => {
          return QueryString.stringify(params, {
            arrayFormat: 'repeat',
          })
        },
      })
    ).data

    /**
     * @TODO: MODEL_QUERY_KEYS.consultations 에 데이터를 저장
     */

    return {
      ...response,
      results: response.results.map(consultation => new Consultation.Level1(consultation)),
    }
  }

  async getPetKinds() {
    const response = (
      await api.get<Pet.Kind[]>('/app/pet_kinds/', {
        withCredentials: true,
      })
    ).data

    return response
  }
}

const AppDataRepository = new AppDataRepositoryImpl()
export default AppDataRepository
